export default "__VITE_ASSET__1aa8c1d0__"